import React, { useState } from 'react';
import { TemplateContent } from "@ambiguous/templateContent";
export default function Tabs({ items }) {
    var _a, _b;
    const [activeIndex, setActiveIndex] = useState(0);
    if (!items) {
        return (React.createElement("h1", { className: 'text-center' }, "Prid\u0117kite duomen\u0173"));
    }
    return (React.createElement("div", { className: 'ltg-tabs' },
        React.createElement("div", { className: "ltg-tabs-buttons" },
            React.createElement("div", { className: "btn-group btn-group-sm" }, items && items.map((item, index) => {
                return (React.createElement("button", { className: `btn btn-${index === activeIndex ? 'primary' : 'outlined'}`, key: item._id, onClick: () => { setActiveIndex(index); } }, item.label));
            }))),
        React.createElement("div", { className: "ltg-tabs-content", onClick: (ev) => { ev.stopPropagation(); } }, (((_a = items[activeIndex]) === null || _a === void 0 ? void 0 : _a.content_type) === 'template' && ((_b = items[activeIndex].template) === null || _b === void 0 ? void 0 : _b.id)) ? (React.createElement(DynamicContent, { template: items[activeIndex].template })) : (React.createElement(StaticContent, { content: items[activeIndex].content || '' })))));
}
// function InnerSection(){
// 	return(
// 		<section className="elementor-element elementor-element-edit-mode" data-element_type="section">
// 			<div className="elementor-container">
// 				<div className="elementor-row">
// 				</div>
// 			</div>
// 		</section>
// 	)
// }
function StaticContent({ content }) {
    return (React.createElement("div", { className: "ltg-accordion-content-wrap" },
        React.createElement("div", { className: "ltg-accordion-content", dangerouslySetInnerHTML: { __html: content } })));
}
function DynamicContent({ template }) {
    return (React.createElement("div", { className: "ltg-accordion-content-wrap" },
        React.createElement("div", { className: "ltg-accordion-content" }, TemplateContent(template === null || template === void 0 ? void 0 : template.id))));
}
